import React from "react";
import { Field } from "formik";
import { isFunction } from "lodash";

const validateField = value => {
  let error;
  if (!value) {
    error = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(value)) {
    error = "Invalid email address";
  }
  return error;
};

class EmailText extends React.PureComponent {
  render() {
    const { name, validate, title, errors, submitCount, touched } = this.props;

    let className =
      (errors[name] && (touched[name] || !!submitCount)
        ? "error is-invalid"
        : "") + " text-input form-control";

    return (
      <React.Fragment>
        {title &&  <label>{title}</label>}
        <div className="input-group mb-3">
          <Field
            name={name}
            className={className}
            {...this.props}
            validate={
              validate && (isFunction(validate) ? validate : validateField)
            }
          />
          {/* <input
                        id="email"
                        placeholder="Enter your email"
                        type="text"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={
                            (errors.email && (touched.email || !!submitCount) ? 'error is-invalid' : '') + ' text-input form-control'
                        }
                    /> */}

          {errors[name] && touched[name] && (
            <div className="invalid-feedback">{errors[name]}</div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default EmailText;
